// components/StoreHours.js
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBusinessById, updateBusinessHours } from "./slices/businessSlice";
import "./StoreHours.css";

const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export default function StoreHours({ businessId }) {
  console.log(businessId,"businessIdbusinessId")
  const dispatch = useDispatch();
  const { business, hoursUpdating, hoursError } = useSelector((s) => s.business);
  const [hours, setHours] = useState(business?.hours || {});

  useEffect(() => {
    dispatch(fetchBusinessById(businessId));
  }, [dispatch, businessId]);

  useEffect(() => {
    if (business?.hours) setHours(business.hours);
  }, [business]);
console.log(business,"updateBusinessHours")
  const handleChange = (day, field) => (e) => {
    const val = field === "closed" ? e.target.checked : e.target.value;
    setHours((h) => ({
      ...h,
      [day]: { ...h[day], [field]: val },
    }));
  };

  const save = () => {
    dispatch(updateBusinessHours({ businessId, hours }));
  };

  return (
    <div className="storehours-container">
      <h2 className="storehours-title">Store Hours</h2>

      <div className="hours-list">
        {days.map((day) => {
          const { open, close, closed } = hours[day] || {};
          return (
            <div key={day} className="hours-row">
              <div className="hours-day">{day.charAt(0).toUpperCase() + day.slice(1)}</div>

              <div className="hours-inputs">
                <label className="closed-toggle">
                  <input
                    type="checkbox"
                    checked={closed || false}
                    onChange={handleChange(day, "closed")}
                  />
                  Closed
                </label>

                {!closed && (
                  <div className="time-range">
                    <input
                      type="time"
                      value={open || ""}
                      onChange={handleChange(day, "open")}
                    />
                    <span className="dash">–</span>
                    <input
                      type="time"
                      value={close || ""}
                      onChange={handleChange(day, "close")}
                    />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {hoursError && <p className="error-text">{hoursError.error || hoursError}</p>}

      <button onClick={save} disabled={hoursUpdating} className="save-hours-btn">
        {hoursUpdating ? "Saving…" : "Save Hours"}
      </button>
    </div>
  );
}
